import React, { useState, useEffect } from 'react';
import { CheckCircle, Circle, Loader } from 'lucide-react';
import { API_CONFIG } from './config/apiConfig';

const getHeaders = () => ({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Admin-Token': localStorage.getItem('cinestream_token') || ''
});

const WatchedButton = ({ movie, user, onStatusChange }) => {
    const [isWatched, setIsWatched] = useState(false);
    const [loading, setLoading] = useState(false);

    // Vérifier le statut au montage
    useEffect(() => {
        if (movie?.id && user?.id) {
            checkWatchedStatus();
        }
    }, [movie?.id, user?.id]);

    const checkWatchedStatus = async () => {
        try {
            const response = await fetch(
                `${API_CONFIG.NEW_API_BASE}/watched?user_id=${user.id}&movie_id=${movie.id}`,
                { headers: getHeaders() }
            );
            const data = await response.json();

            if (data.success) {
                setIsWatched(data.watched);
            }
        } catch (error) {
            console.error('Erreur lors de la vérification du statut:', error);
        }
    };

    const toggleWatched = async (e) => {
        e.stopPropagation(); // Empêcher la propagation du clic

        if (loading) return;

        setLoading(true);

        try {
            const response = await fetch(`${API_CONFIG.NEW_API_BASE}/watched`, {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify({
                    action: 'toggle',
                    user_id: user.id,
                    movie_id: movie.id,
                    movie_title: movie.title
                })
            });

            const data = await response.json();

            if (data.success) {
                setIsWatched(data.watched);

                // Notifier le parent du changement
                if (onStatusChange) {
                    onStatusChange(data.watched);
                }
            }
        } catch (error) {
            console.error('Erreur lors du toggle:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <button
            onClick={toggleWatched}
            disabled={loading}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg font-semibold transition-all ${
                isWatched
                    ? 'bg-green-600 hover:bg-green-700 text-white'
                    : 'bg-white/10 hover:bg-white/20 text-white border border-white/20'
            } ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
            title={isWatched ? 'Marquer comme non regardé' : 'Marquer comme regardé'}
        >
            {loading ? (
                <Loader className="w-5 h-5 animate-spin" />
            ) : isWatched ? (
                <CheckCircle className="w-5 h-5" />
            ) : (
                <Circle className="w-5 h-5" />
            )}
            <span className="hidden sm:inline">
                {isWatched ? 'Regardé' : 'Marquer comme vu'}
            </span>
            <span className="sm:hidden">
                {isWatched ? 'Vu' : 'Vu'}
            </span>
        </button>
    );
};

export default WatchedButton;